export default __webpack_public_path__ + "static/media/Loader.05b3bfa7.svg";